"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BottleneckRow = void 0;
const react_1 = __importDefault(require("react"));
const components_1 = require("@veeam/components");
const location16_svg_1 = __importDefault(require("../../../../../../assets/icons/dashboard/location16.svg"));
const components_2 = require("../../../../../../components");
const components_3 = require("../../../../../../components/DashboardWidgets/components");
const helpers_1 = require("../../../../../../helpers");
require("./types");
const constants_1 = require("./constants");
exports.BottleneckRow = react_1.default.memo(({ icon, text, description, isRegion, content, date }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(components_3.Cell, { width: "60%" },
            react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.column, gap: components_1.STACK_GAP.xs },
                react_1.default.createElement(components_2.IconWithText, { icon: icon, text: text, description: date ? helpers_1.formatDate(date, { format: constants_1.BOTTLENECKS_DATETIME_FORMAT }) : undefined, hasDate: true }),
                description && (react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.row, gap: components_1.STACK_GAP.xs, style: { marginLeft: components_1.SIZE_XXL } },
                    isRegion && react_1.default.createElement(components_1.Icon, { src: location16_svg_1.default }),
                    react_1.default.createElement(components_1.Text, null, description))))),
        react_1.default.createElement(components_3.Cell, { width: "10%" }),
        content));
});
//# sourceMappingURL=BottleneckRow.js.map